import React from 'react';
import QdtComponent from '../components/QdtComponent';
import logo from '../assets/Qlik-Logo_RGB.png';

const Home = () => (
  <div>

    <div className="row pt-2 pb-2">
      <div className="col-7">
        <h1>RAAM 2019</h1>
      </div>
      <div className="col-5">
        <img src={logo} alt="logo" className="logo" />
      </div>
    </div>

    <div className="row pt-2 pb-5">
      <div className="col-12 col-md-2 d-flex align-items-center justify-content-between justify-content-md-around flex-row flex-md-column bd-highlight mb-3 order-2 order-md-1">
        <div className="p-2">
          <div className="col-12 kpi1">39</div>
          <div className="col-12 kpi2">RIDERS</div>
        </div>
        <div className="p-2">
          <div className="col-12 kpi1">19</div>
          <div className="col-12 kpi2">COUNTRIES</div>
        </div>
        <div className="p-2">
          <div className="col-12 kpi1">44%</div>
          <div className="col-12 kpi2">ROOKIES</div>
        </div>
      </div>
      <div className="col-md-10 order-1 order-md-2" style={{ height: 418 }}>
        <QdtComponent type="QdtViz" props={{ id: 'cJasvc', width: '100%', height: '418px' }} />
      </div>
    </div>

    <div className="row nav-selections">
      <div className="col-md-12">
        <div className="d-inline-block p-2">
          <QdtComponent
            type="QdtFilter"
            props={{
              cols: ['GenderName'],
              placeholder: 'Gender',
              single: true,
              autoSortByState: 0,
              showStateInDropdown: true,
            }}
          />
        </div>
        <div className="d-inline-block p-3">
          <QdtComponent
            type="QdtFilter"
            props={{
              cols: ['Age Group'],
              placeholder: 'Age Group',
              single: true,
              autoSortByState: 0,
              showStateInDropdown: true,
            }}
          />
        </div>
        <div className="d-inline-block p-3">
          <QdtComponent
            type="QdtSelectionToolbar"
            props={{
              type: 'QdtSelectionToolbar',
              height: '100px',
            }}
          />
        </div>
      </div>
    </div>

    <div className="row pt-5 pb-5">
      <div className="col-12 col-md-6">
        <h1>RAAM HISTORICAL STATS</h1>
        <div className="children-inline">
On June 11th, 39 riders from across the globe will race from Oceanside, California to Annapolis, Maryland vying to be crowned champion of the world’s toughest bicycle race. Over the last 37 years,
          {' '}
          <QdtComponent type="QdtKpi" props={{ cols: ['=Count(Distinct Rider)'] }} />
          {' '}
riders from
          {' '}
          <QdtComponent type="QdtKpi" props={{ cols: ['=Count(Distinct Country_mapped)'] }} />
          {' '}
countries have participated in the Race Across America. Use the data from the past
          {' '}
          <QdtComponent type="QdtKpi" props={{ cols: ['=Count(Distinct Year)'] }} />
          {' '}
races to find interesting insights.
        </div>
        {/* <h5>Winners are historians... and analysts</h5> */}
        {/* <div>Understanding RAAM history helps write the perfect race plan. Go, play, with the 36 history of this epic adventure.</div> */}
      </div>
      <div className="col-4 col-md-2 d-flex align-items-md-center border-right">
        <div className="row flex-fill">
          <div className="col-12 kpi1"><QdtComponent type="QdtKpi" props={{ cols: ['=Count(Distinct Rider)'] }} /></div>
          <div className="col-12 kpi2">RIDERS</div>
        </div>
      </div>
      <div className="col-4 col-md-2 d-flex align-items-center border-right">
        <div className="row flex-fill">
          <div className="col-12 kpi1"><QdtComponent type="QdtKpi" props={{ cols: ['=Count(Distinct Year)'] }} /></div>
          <div className="col-12 kpi2">RACES</div>
        </div>
      </div>
      <div className="col-4 col-md-2 d-flex align-items-center">
        <div className="row flex-fill">
          <div className="col-12 kpi1"><QdtComponent type="QdtKpi" props={{ cols: ['=Count(Distinct Country_mapped)'] }} /></div>
          <div className="col-12 kpi2">COUNTRIES</div>
        </div>
      </div>
    </div>

    <div className="row pt-5 pb-5">
      <div className="col-12 col-md-4">
        <QdtComponent type="QdtViz" props={{ id: 'Fxmzxb', width: '100%', height: '300px' }} />
      </div>
      <div className="col-12 pt-5 pt-md-0 col-md-4">
        <QdtComponent type="QdtViz" props={{ id: 'QnEZB', width: '100%', height: '300px' }} />
      </div>
      <div className="col-12 pt-5 pt-md-0 col-md-4">
        <QdtComponent type="QdtViz" props={{ id: 'WEwzFZj', width: '100%', height: '300px' }} />
      </div>
    </div>

    <div className="row pt-5 pb-5">
      <div className="col-md-6 mb-2 mb-md-0">
        <div className="col-12 fastest">
          <div className="rules">
            <div className="line bg-red" />
            <div className="line bg-black" />
            <div className="line bg-blue" />
          </div>
          <h2>FASTEST MAN</h2>
          <div className="name">
            <QdtComponent
              type="QdtKpi"
              props={{
                cols: ["=If(Isnull(Max({<Gender={'M'} >} Time)), '',If(ISNULL(Firstsortedvalue(Rider,Aggr(Min({<Gender={'M'} >} Time), Rider))), Count({<Time={'$(=Min({<Gender={'M'} >} Time))'}  >} Distinct Rider) & ' riders tied',Firstsortedvalue(Rider,Aggr(Min({<Gender={'M'} >} Time), Rider))))& ', ' &If(Isnull(Max({<Gender={'M'} >} Time)), '',If(ISNULL(Firstsortedvalue(Rider,Aggr(Min({<Gender={'M'} >} Time), Rider))), Count({<Time={'$(=Min({<Gender={'M'} >} Time))'}  >} Distinct Rider) & ' riders tied',Firstsortedvalue(Year, Aggr(Min({<Gender={'M'} >} Time), Rider, Year))))"],
              }}
            />
          </div>
          {/* <div className="time"><QdtComponent type="QdtKpi" props={{ cols: ["=Min({<Gender={'M'} >} Time)"] }} /></div> */}
          <div className="time"><QdtComponent type="QdtKpi" props={{ cols: ["=If(Isnull(Max({<Gender={'M'} >} Time)), '', If(ISNULL(Firstsortedvalue(Rider,Aggr(Min({<Gender={'M'} >} Time), Rider))), Count({<Time={'$(=Min({<Gender={'M'} >} Time))'}  >} Distinct Rider) & ' riders tied', Firstsortedvalue(Days, Aggr(Min({<Gender={'M'} >} Time), Rider, Year)))) & ' days ' & If(Isnull(Max({<Gender={'M'} >} Time)), '', If(ISNULL(Firstsortedvalue(Rider,Aggr(Min({<Gender={'M'} >} Time), Rider))), Count({<Time={'$(=Min({<Gender={'M'} >} Time))'}  >} Distinct Rider) & ' riders tied', Firstsortedvalue(Hours, Aggr(Min({<Gender={'M'} >} Time), Rider, Year)))) & ' hrs ' & If(Isnull(Max({<Gender={'M'} >} Time)), '', If(ISNULL(Firstsortedvalue(Rider,Aggr(Min({<Gender={'M'} >} Time), Rider))), Count({<Time={'$(=Min({<Gender={'M'} >} Time))'}  >} Distinct Rider) & ' riders tied', Firstsortedvalue(Mins, Aggr(Min({<Gender={'M'} >} Time), Rider, Year)))) & ' mins ' "] }} /></div>
          <div className="distance">
            <div className="d-inline-block pr-3 children-inline">
              <QdtComponent type="QdtKpi" props={{ cols: ["=If(Isnull(Max({<Gender={'M'} >} Time)), '', If(ISNULL(Firstsortedvalue(Rider,Aggr(Min({<Gender={'M'} >} Time), Rider))), Count({<Time={'$(=Min({<Gender={'M'} >} Time))'}  >} Distinct Rider) & ' riders tied', Firstsortedvalue(Miles, Aggr(Min({<Gender={'M'} >} Time), Rider, Year))))"] }} />
              {' '}
miles
            </div>
            <div className="d-inline-block children-inline">
              <QdtComponent type="QdtKpi" props={{ cols: ['=Max({<Gender={\'M\'} >}[Avg MPH])'] }} />
              {' '}
mph
            </div>
          </div>
        </div>
      </div>
      <div className="col-md-6">
        <div className="col-12 fastest">
          <div className="rules">
            <div className="line bg-red" />
            <div className="line bg-black" />
            <div className="line bg-blue" />
          </div>
          <h2>FASTEST WOMAN</h2>
          <div className="name">
            <QdtComponent
              type="QdtKpi"
              props={{
                cols: ["=If(Isnull(Max({<Gender={'F'} >} Time)), '',If(ISNULL(Firstsortedvalue(Rider,Aggr(Min({<Gender={'F'} >} Time), Rider))), Count({<Time={'$(=Min({<Gender={'F'} >} Time))'}  >} Distinct Rider) & ' riders tied',Firstsortedvalue(Rider,Aggr(Min({<Gender={'F'} >} Time), Rider))))& ', ' & If(Isnull(Max({<Gender={'F'} >} Time)), '',If(ISNULL(Firstsortedvalue(Rider,Aggr(Min({<Gender={'F'} >} Time), Rider))), Count({<Time={'$(=Min({<Gender={'F'} >} Time))'}  >} Distinct Rider) & ' riders tied',Firstsortedvalue(Year, Aggr(Min({<Gender={'F'} >} Time), Rider, Year))))"],
              }}
            />
          </div>
          <div className="time"><QdtComponent type="QdtKpi" props={{ cols: ["=If(Isnull(Max({<Gender={'F'} >} Time)), '', If(ISNULL(Firstsortedvalue(Rider,Aggr(Min({<Gender={'F'} >} Time), Rider))), Count({<Time={'$(=Min({<Gender={'F'} >} Time))'}  >} Distinct Rider) & ' riders tied', Firstsortedvalue(Days, Aggr(Min({<Gender={'F'} >} Time), Rider, Year)))) & ' days ' & If(Isnull(Max({<Gender={'F'} >} Time)), '', If(ISNULL(Firstsortedvalue(Rider,Aggr(Min({<Gender={'F'} >} Time), Rider))), Count({<Time={'$(=Min({<Gender={'F'} >} Time))'}  >} Distinct Rider) & ' riders tied', Firstsortedvalue(Hours, Aggr(Min({<Gender={'F'} >} Time), Rider, Year)))) & ' hrs ' & If(Isnull(Max({<Gender={'F'} >} Time)), '', If(ISNULL(Firstsortedvalue(Rider,Aggr(Min({<Gender={'F'} >} Time), Rider))), Count({<Time={'$(=Min({<Gender={'F'} >} Time))'}  >} Distinct Rider) & ' riders tied', Firstsortedvalue(Mins, Aggr(Min({<Gender={'F'} >} Time), Rider, Year)))) & ' mins ' "] }} /></div>
          <div className="distance">
            <div className="d-inline-block pr-3 children-inline">
              <QdtComponent type="QdtKpi" props={{ cols: ["=If(Isnull(Max({<Gender={'F'} >} Time)), '', If(ISNULL(Firstsortedvalue(Rider,Aggr(Min({<Gender={'F'} >} Time), Rider))), Count({<Time={'$(=Min({<Gender={'F'} >} Time))'}  >} Distinct Rider) & ' riders tied', Firstsortedvalue(Miles, Aggr(Min({<Gender={'F'} >} Time), Rider, Year))))"] }} />
              {' '}
miles
            </div>
            <div className="d-inline-block children-inline">
              <QdtComponent type="QdtKpi" props={{ cols: ['=Max({<Gender={\'F\'} >}[Avg MPH])'] }} />
              {' '}
mph
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="row pt-5 pb-5">
      <div className="col-12 col-md-6">
        <QdtComponent type="QdtViz" props={{ id: 'YdHnhtM', width: '100%', height: '300px' }} />
      </div>
      <div className="col-12 pt-5 pt-md-0 col-md-6">
        <QdtComponent type="QdtViz" props={{ id: 'zpBdQRj', width: '100%', height: '300px' }} />
      </div>
    </div>

    <div className="row pt-5 pb-5">
      <div className="col-md-12">
        <h2>PARTICIPANT DETAILS</h2>
      </div>
      <div className="col-md-12">
        <QdtComponent type="QdtViz" props={{ id: 'mDrPK', width: '100%', height: '500px' }} />
      </div>
    </div>

  </div>
);

export default Home;
